'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCatalogCuratorsIfNeeded = exports.getLoadTimeForCatalogCurators = exports.getCatalogCurators = exports.isLoading = exports.FETCH_CATALOG_CURATORS_FAIL = exports.FETCH_CATALOG_CURATORS_SUCCESS = exports.FETCH_CATALOG_CURATORS_REQUEST = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _user = require('../modules/user');

var _config = require('../modules/config');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var FETCH_CATALOG_CURATORS_REQUEST = exports.FETCH_CATALOG_CURATORS_REQUEST = 'FETCH_CATALOG_CURATORS_REQUEST';
var FETCH_CATALOG_CURATORS_SUCCESS = exports.FETCH_CATALOG_CURATORS_SUCCESS = 'FETCH_CATALOG_CURATORS_SUCCESS';
var FETCH_CATALOG_CURATORS_FAIL = exports.FETCH_CATALOG_CURATORS_FAIL = 'FETCH_CATALOG_CURATORS_FAIL';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;
    var catalogId = void 0;

    switch (action.type) {
        case FETCH_CATALOG_CURATORS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.catalogId])
            });
        case FETCH_CATALOG_CURATORS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case FETCH_CATALOG_CURATORS_SUCCESS:
            catalogId = action.meta.catalogId;
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            existing[catalogId] = action.payload;
            loaded[catalogId] = time;
            loading = (0, _difference2.default)(loading, [catalogId]);

            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.catalogCurators;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var isLoading = exports.isLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var getCatalogCurators = exports.getCatalogCurators = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || [];
});

var getLoadTimeForCatalogCurators = exports.getLoadTimeForCatalogCurators = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var shouldFetchCurators = function shouldFetchCurators(state, catalogId) {
    if (!catalogId) return false;
    var curators = getCatalogCurators(state, catalogId);
    if (!(0, _isEmpty2.default)(curators)) {
        var loaded = getLoadTimeForCatalogCurators(state, catalogId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    } else if (getLoadTimeForCatalogCurators(state, catalogId)) {
        return false;
    }
    var loading = isLoading(state, catalogId);
    return !loading;
};

/* ACTION CREATORS */
var fetchCatalogCuratorsIfNeeded = exports.fetchCatalogCuratorsIfNeeded = function fetchCatalogCuratorsIfNeeded(catalogId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();

                            if (!shouldFetchCurators(state, catalogId)) {
                                _context.next = 17;
                                break;
                            }

                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            _context.prev = 4;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: catalogId,
                                type: FETCH_CATALOG_CURATORS_REQUEST
                            });
                            _context.next = 8;
                            return _api.Catalog.fetchCuratorsForCatalog({
                                authToken: authToken,
                                catalogId: catalogId,
                                deployment: deployment
                            });

                        case 8:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), catalogId: catalogId },
                                payload: response.data,
                                type: FETCH_CATALOG_CURATORS_SUCCESS
                            });
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](4);

                            dispatch({
                                error: true,
                                meta: { catalogId: catalogId },
                                payload: _context.t0,
                                type: FETCH_CATALOG_CURATORS_FAIL
                            });

                        case 15:
                            _context.next = 18;
                            break;

                        case 17:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 18:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[4, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/catalogCurators.js
// module id = UTtJ
// module chunks = 57